import React from "react";

const JQuery_Get = () => {
  return (
    <div>
      <h1>JQuery_Get</h1>
      <p>Placeholder component for: "JQuery_Get"</p>
    </div>
  );
};

export default JQuery_Get;
